var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWatermark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 32,
    viewBox: "0 0 134 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14104_65183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2928 6.28759L17.9004 18.2166V25.4H13.9068V18.2166L7.29391 6.28759H12.0007L15.9684 14.612L19.7675 6.28759H24.2928ZM39.8784 17.0497H30.5944V21.9639H41.175V25.4H26.6916V6.28759H40.7082V9.67181H30.5944V13.7303H39.8784V17.0497ZM52.4039 18.5278H48.3454V25.4H44.3777V6.28759H52.7021C54.6211 6.28759 56.1511 6.78031 57.2922 7.76575C58.4332 8.75119 59.0037 10.2769 59.0037 12.3429C59.0037 14.599 58.4332 16.1939 57.2922 17.1275C56.1511 18.061 54.5217 18.5278 52.4039 18.5278ZM54.271 14.5472C54.7897 14.089 55.049 13.3629 55.049 12.3688C55.049 11.3747 54.7853 10.6659 54.258 10.2423C53.7394 9.81876 53.009 9.60697 52.0667 9.60697H48.3454V15.2344H52.0667C53.009 15.2344 53.7437 15.0053 54.271 14.5472ZM61.6878 6.28759H65.6555V25.4H61.6878V6.28759ZM82.8748 23.9737C81.4485 25.279 79.6246 25.9316 77.403 25.9316C74.6541 25.9316 72.4931 25.0499 70.9198 23.2865C69.3466 21.5144 68.5599 19.0854 68.5599 15.9994C68.5599 12.6627 69.4546 10.0911 71.244 8.28441C72.7999 6.71116 74.7795 5.92453 77.1826 5.92453C80.3982 5.92453 82.7494 6.97913 84.2363 9.08832C85.0575 10.2726 85.4983 11.4612 85.5588 12.6541H81.5652C81.3059 11.7378 80.9731 11.0462 80.5668 10.5795C79.8407 9.7496 78.7645 9.33468 77.3382 9.33468C75.8859 9.33468 74.7406 9.92249 73.9021 11.0981C73.0636 12.2651 72.6443 13.9204 72.6443 16.0642C72.6443 18.208 73.0852 19.8158 73.9669 20.8877C74.8573 21.9509 75.9853 22.4826 77.3511 22.4826C78.7515 22.4826 79.8191 22.0244 80.5538 21.1081C80.9601 20.6154 81.2972 19.8763 81.5652 18.8909H85.5199C85.1742 20.9741 84.2924 22.6684 82.8748 23.9737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.598 10.24H117.214L121.128 21.3051H118.624L117.893 19.0311H113.819L113.069 21.3051H110.651L114.598 10.24ZM114.448 17.1303H117.281L115.884 12.7753L114.448 17.1303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2 21.3051H123.902V10.24H126.2V21.3051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.111 19.2291C102.886 19.2291 104.325 17.7899 104.325 16.0146C104.325 14.2392 102.886 12.8 101.111 12.8C99.3354 12.8 97.8962 14.2392 97.8962 16.0146C97.8962 17.7899 99.3354 19.2291 101.111 19.2291Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14104_65183",
    x: -3.40006,
    y: -3.84,
    width: 140.8,
    height: 39.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14104_65183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14104_65183",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWatermark);
export default __webpack_public_path__ + "static/media/logoWatermark.552c5abddfd8d1595d9abf8dde51706f.svg";
export { ForwardRef as ReactComponent };